<template>
  <div class="col-12">
    <div class="row">
      <div class="card bg-white rounded w-100">
        <div class="card-body column">
          <div class="row w-100 border-bottom pb-2">
            <div class="col-md-8">
              <div class="media d-flex align-items-center justify-content-start">
                <img 
                  src="@assets/images/users/avatar-7.jpg" 
                  class="mr-3 avatar-xl rounded" 
                  alt="shreyu"
                  ref="avatarPath"
                >
                <div class="media-body column">
                  <div>
                    <h5 class="mt-1 mb-0">{{ model.title }}</h5>
                    <h6 class="font-weight-normal mt-1 mb-1 d-flex justify-content-start align-items-center">
                      <span v-if="model.company_id" class="mr-2">{{ model.company_id.name }}</span>
                      <div v-if="model.company_id && model.company_id.name" class="dot_container mr-2"></div>
                      <span>{{ computedLocation }}</span>
                    </h6>
                    <p class="mb-0">
                      <span
                        class="mt-1 mb-2 text-right badge  badge-pill"
                        :class="model.active ? 'badge-success' : 'badge-danger'"
                      >
                        {{ model.active ? $t('job.badges.active') : $t('job.badges.deactivated') }}
                      </span>

                      <span
                        class="mt-1 mb-2 mx-2 text-right badge  badge-pill"
                        :class="model.published ? 'badge-success' : model.posted ? 'badge-soft-danger' : 'badge-soft-secondary'"
                      >
                        {{ model.published ? 'Posted' : model.posted ? 'Unposted' : 'Draft' }}
                      </span>

                      <span
                        class="mt-1 mb-2 mx-1 text-right badge  badge-pill badge-danger"
                        v-if="!model.remaining"
                      >
                        {{ $t('job.badges.no_slot') }}
                      </span>
                    </p>
                  </div>

                  <p class="text-muted mb-0 d-flex flex-row align-items-center">
                    <span
                      class="mr-3 d-flex align-items-center flex-row"
                      v-if="model.company_id && model.company_id.contact_no"
                    >
                      <i class="mr-1 uil-phone  d-flex align-items-center flex-row"></i>
                      {{ model.company_id.contact_no }}
                    </span>
                    <span
                      class="mr-3 d-flex align-items-center flex-row"
                      v-if="model.company_id && model.company_id.email"
                    >
                      <i class="mr-1 uil-envelope  d-flex align-items-center flex-row"></i>
                      {{ model.company_id.email }}
                    </span>
                    <span
                      class="mr-1 d-flex align-items-center flex-row" 
                      v-if="model.company_id && model.company_id.website"
                    >
                      <i class="mr-1 uil-globe  d-flex align-items-center flex-row"></i>
                      <a :href="model.company_id.website" target="_blank">{{ model.company_id.website }}</a>
                    </span>
                    <span
                      class="mr-1 d-flex align-items-center flex-row" 
                      v-if="model.url && role_modules.some(item => item.value == 'job.view_source')"
                    >
                      <i class="mr-1 uil-link  d-flex align-items-center flex-row"></i>
                      <a :href="model.url" v-if="!model.nourl" target="_blank">View Job Source</a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div 
              class="col-md-4 col-sm-4 text-right d-flex flex-column justify-content-start align-items-end setting_dropdown_container"
              v-if="!hasNoSetting"
            >
              <input readonly hidden id="copyURL" ref="copyURL" v-model="job_url">
              <input readonly hidden id="copyCompanyURL" ref="copyCompanyURL" v-model="job_company_url">

              <b-nav-item-dropdown
                right
                no-caret
                variant="black"
                class="dropdown d-none d-lg-block"
              >
                <template v-slot:button-content>
                  <p title="Setting" class="h4 my-0 py-0 text-muted">
                    ...
                  </p>
                </template>
                <!-- item-->
                <!-- <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="urlGenerate(false)"
                  v-if="job_url === '' && (user.role.role == 'administration' || user.role.role == 'staff')"
                >
                  <i class="uil uil-link-alt mr-1" />
                  Generate URL
                </b-dropdown-item> -->
                <!-- <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onCopyUrl(job_url)"
                >
                  <i class="uil uil-copy mr-1" />
                  Copy URL
                </b-dropdown-item> -->
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="urlGenerate(true)"
                  v-if="job_company_url === '' && role_modules.some(item => item.value == 'job.generate_url')" 
                >
                  <i class="uil-file-copy-alt mr-1" />
                  {{ role_modules.some(item => item.value == 'job.generate_url') ? 'Generate URL' : 'Generate URL' }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onCopyUrl(job_company_url)"
                  v-else
                >
                  <i class="uil-copy-alt mr-1" />
                  {{ role_modules.some(item => item.value == 'job.generate_url') ? 'Copy URL' : 'Copy URL' }} 
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="$refs.submitCandidate.show()"
                  v-if="model.active && (model.slots - model.hired) > 0 && role_modules.some(item => item.value == 'job.generate_url')"
                >
                  <i class="uil-message mr-1" />
                  {{ $t('job.action.submit_candidate') }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="role_modules.some(item => item.value == 'job.activate')"
                  @click="onActivate"
                >
                  <i
                    class="mr-1"
                    :class="model.active ? 'uil-times-circle' : 'uil-check-circle'" 
                  />
                  {{ !model.active ? $t('job.action.activate') : $t('job.action.deactivate') }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="role_modules.some(item => item.value == 'job.post')"
                  @click="onPublish"
                >
                  <i
                    class="mr-1"
                    :class="model.published ? 'uil-file-times' : 'uil-file-check'"
                  />
                  {{ !model.published ? 'Post' : 'Unpost' }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="role_modules.some(item => item.value == 'job.edit') && !model.published"
                  @click="onClickEdit"
                >
                   <i class="uil uil-edit mr-1" />
                   {{ $t('common.edit') }}
                </b-dropdown-item>
                <!-- <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="(model.title_changed || model.description_changed)"
                  @click="onUpdateOriginal"
                >
                  <i class="uil-angle-right mr-1" />
                  {{ $t('job.action.update_job_changed') }}
                </b-dropdown-item> -->
                <!-- <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="user.role.role == 'administration' && !model.published"
                  @click="onClickDelete"
                  role_modules.some(item => item.value == 'job.update_changed_fields') && 
                >
                   <i class="uil uil-trash-alt mr-1" />
                   Delete
                </b-dropdown-item> -->

              </b-nav-item-dropdown>
            </div>
          </div>
          <div class="row border-top w-100 d-flex justify-content-between px-3 align-items-center pt-3">
            <div 
              class="d-flex justify-content-center align-items-center"
              :class="{
                'text-left': model.ats_id,
                'text-center': !model.ats_id
              }"
            >
              <img class="vincere_size" src="@assets/vincere-icon.png" >
              <div>
                <p class="mb-0 small_titles">ATS ID</p>
                <p class="h6 my-0">{{ model.ats_id || "-" }}</p>
              </div>
            </div>
            <div
              class="d-flex justify-content-center align-items-center"
              :class="{
                'text-left': model.reference_no,
                'text-center': !model.reference_no
              }"
            >
              <p class="h3 my-0 mr-1 font-weight-boldest">#</p>
              <div>
                <p class="mb-0 small_titles">{{ $t('job.form.reference_no.label') }}</p>
                <p class="h6 my-0">{{ model.reference_no || "-" }}</p>
              </div>
            </div>
            <div 
              class="d-flex justify-content-center align-items-center"
              :class="{
                'text-left': model.employment_type,
                'text-center': !model.employment_type
              }"
            >
              <i class="uil-bag h3 mr-1 my-0"></i>
              <div>
                <p class="mb-0 small_titles">{{ $t('job.form.employment_type.label') }}</p>
                <p class="h6 my-0">
                  <span class="mr-2">{{ computedEmploymentType }}</span>
                  <span v-if="model.level" class="dot_container mr-1" style="display: inline-block;" />
                  {{ model.level }}
                </p>
              </div>
            </div>
            <div 
              class="d-flex text-left justify-content-center align-items-center"
            >
              <p class="h2 my-0 mr-2">{{ model.currency_id.symbol }}</p>
              <div>
                <p class="mb-0 small_titles">
                  {{ model.use_min_max_salary ? $t('job.form.salary_range') : 'Salary' }}
                </p>
                <p class="h6 my-0" v-if="model.use_min_max_salary">
                  {{ model.min_salary ? model.min_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }} - {{ model.max_salary ? model.max_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }}
                </p>
                <p class="h6 my-0" v-else>
                  {{ computedSalaryFormatter || "-" }}
                </p>
              </div>
            </div>
            <div class="text-left d-flex justify-content-start align-items-center">
              <i class="uil-money-bill h3 mr-2 my-0"></i>
              <div>
                <p class="mb-0 small_titles">Pay Rate</p>
                <p class="h6 my-0">
                  {{ model.max_salary ? model.max_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }}
                </p>
              </div>
            </div>
          </div>
          <div class="row w-100 d-flex px-3 justify-content-between align-items-center pt-3">
            <div class="text-left d-flex justify-content-start align-items-center">
              <p class="h3 my-0 mr-2 font-weight-boldest">%</p>
              <div>
                <p class="mb-0 small_titles">My Fee</p>
                <p class="h6 my-0">
                  {{ user.fixed && user.rate ? user.rate.$numberDecimal : '' | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }}
                  {{ !user.fixed && user.rate ? user.rate.$numberDecimal + '%' : '' }}
                </p>
              </div>
            </div>
            <div 
              class="d-flex text-left justify-content-center align-items-center"
            >
              <i class="uil-user h3 mr-1 my-0"></i>
              <div>
                <p class="mb-0 small_titles">{{ $t('job.form.slots.label') }}</p>
                <p class="h6 my-0">
                  {{ (model.slots - model.hired) > 0 ? model.slots - model.hired : 0 }} / {{ model.slots }}
                </p>
              </div>
            </div>
            <div class="text-left d-flex justify-content-start align-items-center">
              <p class="h3 my-0 mr-2 font-weight-boldest"><i class="uil-file-lock-alt"></i></p>
              <div>
                <p class="mb-0 small_titles">Function(s)</p>
                <p class="h6 my-0" v-if="model.function_id && model.function_id.length">
                  <span class="badge badge-pill badge-soft-primary mr-2 mb-2 font-weight-bold" 
                    v-for="item in model.function_id"
                    :key="item._id">
                    {{ item.name }}
                  </span>
                </p>
                <span class="text-center" style="font-size: 12px;" v-else>No function(s) available</span>
              </div>
            </div>
            <div class="text-left d-flex justify-content-start align-items-center">
              <p class="h3 my-0 mr-2 font-weight-boldest"><i class="uil-building"></i></p>
              <div>
                <p class="mb-0 small_titles">Industry(ies)</p>
                <p class="h6 my-0" v-if="model.industry_id && model.industry_id.length">
                  <span class="badge badge-pill badge-soft-primary mr-2 mb-2 font-weight-bold" 
                    v-for="item in model.industry_id"
                    :key="item._id">
                    {{ item.name }}
                  </span>
                </p>
                <span class="text-center" style="font-size: 12px;" v-else>No industry(ies) available</span>
              </div>
            </div>
            <div class="text-left d-flex justify-content-start align-items-center">
              <p class="h3 my-0 mr-2 font-weight-boldest"><i class="uil-tag-alt"></i></p>
              <div>
                <p class="mb-0 small_titles">Skill(s)</p>
                <p class="h6 my-0" v-if="model.tags && model.tags.length">
                  <span class="badge badge-pill badge-soft-primary mr-2 mb-2 font-weight-bold" 
                    v-for="(item, idx) in model.tags"
                    :key="idx">
                    {{ item.text }}
                  </span>
                </p>
                <span class="text-center" style="font-size: 12px;" v-else>No skill(s) available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs pills justified class="col-12 application-view-height bg-white navtab-bg p-2">
        <b-tab title="Summary and Job details" active>
          <div class="card col-12 tab_card_container">
            <div class="tab_description_content_container summary-space" >
              <p class="h5">Summary:</p>
              <span v-if="model.summary" v-html="model.summary"></span>
              <span v-else>No summary(ies) available</span>
            </div>
          </div>

          <div class="card col-12 tab_card_container">
            <div class="tab_description_content_container">
              <p class="h6">Full Details</p>
              <span v-if="model.description || model._id" v-html="job_layout"></span>
              <span v-else>No description(s) available</span>
            </div>
          </div>
        </b-tab>
        <b-tab title="Additional Information">
          <div class="card col-12 tab_card_container">
            <div class="tab_description_content_container">
              <span v-if="model.remarks" v-html="model.remarks"></span>
              <span v-else>No additional information(s) available</span>
            </div>
          </div>
        </b-tab>
        <b-tab title="Notes">
          <div class="col-12 card tab_card_container">
            <div class="w-100 d-flex justify-content-end">
              <label v-show="!hasNoSetting" class="btn btn-sm btn-primary text-center" @click.prevent="$refs.addNotes.show()">
                Add Note
              </label>
            </div>
            <div
              class="d-flex tab_card_content_container align-items-center flex-wrap"
              :class="model.notes && model.notes.length >= 3 ? 'justify-content-between' : 'justify-content-start'"
            >
              <div class="note" v-if="model.notes && model.notes.length == 0">No notes added.</div>
              <div
                class="note note_cards rounded my-2 bg-white"
                v-for="(note) in model.notes"
                :key="note._id"
                v-html="note.description"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <!-- <b-tabs class="w-100">
        <b-tab title="Function(s)" active>
          <div class="card col-12 tab_card_container">
            <div class="tab_description_content_container">
              <p class="my-0" v-if="model.function_id && model.function_id.length">
                <span class="badge badge-pill badge-soft-primary mr-2 mb-2 font-weight-bold" 
                  v-for="item in model.function_id"
                  :key="item._id">
                  {{ item.name }}
                </span>
              </p>
              <span v-else>No description(s) available</span>
            </div>
          </div>
        </b-tab>
        <b-tab title="Industry(ies)">
          <div class="card col-12 tab_card_container">
            <div class="tab_description_content_container">
              <p class="my-0" v-if="model.industry_id && model.industry_id.length">
                <span class="badge badge-pill badge-soft-primary mr-2 mb-2 font-weight-bold" 
                  v-for="item in model.industry_id"
                  :key="item._id">
                  {{ item.name }}
                </span>
              </p>
              <span v-else>No description(s) available</span>
            </div>
          </div>
        </b-tab>
        <b-tab title="Description">
          <div class="card col-12 tab_card_container">
            <div class="tab_description_content_container">
              <span v-if="model.description" v-html="model.description"></span>
              <span v-else>No description(s) available</span>
            </div>
          </div>
        </b-tab>
        <b-tab title="Notes">
          <div class="col-12 card tab_card_container">
            <div class="w-100 d-flex justify-content-end border-bottom">
              <label class="btn btn-sm btn-primary text-center" @click.prevent="$refs.addNotes.show()">
                Add Summary 
              </label>
            </div>
            <div
              class="d-flex tab_card_content_container align-items-center flex-wrap"
              :class="model.notes && model.notes.length >= 3 ? 'justify-content-between' : 'justify-content-start'"
            >
              <div class="note" v-if="model.notes && model.notes.length == 0">No notes added.</div>
              <div
                class="note note_cards rounded my-2 bg-white"
                v-for="(note) in model.notes"
                :key="note._id"
                v-html="note.description"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs> -->
    </div>

    <Dialog
      centered
      title="Add Note"
      size="lg"
      yesText="Add"
      noText="Cancel"
      ref="addNotes"
      :buttonDisable="noteCreated"
      :parameters="{ submitted }"
      :component="notesComponent"
      @onYes="handleSubmit"
    />
    <OffCanvas
      centered
      size="lg"
      customClass="customDialog"
      ref="submitCandidate"
      :title="$t('job.submit_window.window_title')"
      :component="submitCandidateComponent"
      @onClick="onClickActions"
    />
    <OffCanvas
      centered
      size="lg"
      hideHeader
      customClass="customDialog"
      ref="modeSelect"
      title="Select a Candidate"
      :component="selectCandidateComponent"
      :parameters="{ candidates }"
      @onClick="onClickActions"
    />
    <OffCanvas
      centered
      size="lg"
      customClass="customDialog"
      hideHeader
      ref="createCandidate"
      title="Create a Candidate"
      :component="createCandidateComponent"
      :parameters="{ finalModel, is_wizard_manual_reset }"
      @onClick="onClickActions"
    />
    <OffCanvas
      centered
      size="lg"
      customClass="customDialog"
      ref="uploadCandidate"
      title="Upload a Candidate"
      :component="uploadCandidateComponent"
      :parameters="{ finalModel, is_reset_wizard, is_wizard_upload_reset }"
      @onClick="onClickActions"
    />
    <Dialog
      centered
      size="md"
      ref="showGeneratedURL"
      title="Generated URL"
      :component="jobURL"
      :parameters="{ job_url: job_param_url }"
    />
    <Dialog
      centered
      size="lg"
      ref="modalError"
      title="Warning"
      bodyMessage="Candidate already exists on our system. We have forwarded the info to admin and Jinz.ai admin will contact you directly"
      noText="Close"
    />
  </div>
</template>

<script>
import FormMixin from '@mixins/form'
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'

import error from '@utils/error'

export default {
  components: {
    Dialog,
    OffCanvas,
  },
  mixins: [ FormMixin ],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    computedSalaryFormatter() {
      let model = this.model || {}
      let salary = model.salary || ''

      if (salary && salary.length > 30) {
        salary = 0
      }

      return salary
    },
    notesComponent() {
      return () => import('./addNotes.vue')
    },
    endpoint () {
      let parameters = this.parameters || {}
      return parameters.endpoint || 'find'
    },
    hasNoSetting() {
      let parameters = this.parameters || {}
      return parameters.hasNoSetting || false
    },
    moduleName() {
      let parameters = this.parameters || {}
      return parameters.moduleName || 'job'
    },
    submitCandidateComponent() {
      return () => import('./submitCandidate.vue')
    },
    selectCandidateComponent() {
      return () => import('./selectCandidate.vue')
    },
    jobURL () {
      return () => import('./jobURL.vue')
    },
    createCandidateComponent() {
      return () => import('./createCandidate.vue')
    },
    uploadCandidateComponent() {
      return () => import('./uploadCandidate.vue')
    },
    jobID() {
      let parameters = this.parameters || {}
      return parameters.jobID
    },
    previewData() {
      let parameters = this.parameters || {}
      return parameters.model
    },
    editSubmitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
    currency_symbol(){
      var symbol = ""
      if(this.model.currency_id){
        symbol = this.model.currency_id.symbol
      }
      return symbol
    },
    computedLocation() {
      let model = this.model || {}
      let location = ''

      if (model.city && model.country) {
        location = `${this.capitalizeString(model.city)}, ${this.capitalizeString(model.country)}`
      }
      else location = '-'

      return location
    },
    computedEmploymentType() {
      let model = this.model || {}
      let employmentType = ''

      if (model.employment_type) {
        employmentType = `${this.capitalizeString(model.employment_type)}`.replace('_', '-')
      }
      else employmentType = '-'

      return employmentType
    }
  },
  data () {
    return {
      is_wizard_upload_reset: false,
      is_wizard_manual_reset: false,
      is_reset_wizard: false,
      job_url: '',
      job_company_url: '',
      job_param_url: '',
      manual: true,
      noteCreated: false,
      onHovered: false,
      submitted: false,
      finalModel:{
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      },
      job_layout: {},
      model:{
        active:true,
        company_id:{
          name:''
        },
        currency_id:{
          symbol:''
        },
        url: ''
      },
      feedbacks:[],
      application:[],
      candidate:[],
      candidates:[],
      applicants:[],
      placed_applicants:[],
      rejected_applicants:[],
      applicant:{},
      new_applicant:{
        whatId:'candidate_id',
        candidate_id:{
          avatar_path:''
        },
        prospect:{
          avatar_path:''
        }
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      applicantLoading:false,
      placeApplicantLoading:false,
      rejectedApplicantLoading:false,
      loadSelectCandidate:false,
      status_option:[
        { value: 'Sent', text: 'Sent' },
        { value: 'First Interview', text: 'First Interview' },
        { value: 'Second Interview', text: 'Second Interview' }
      ],
    }
  },
  methods: {
    onCopyUrl(job_url) {
      this.job_param_url = job_url
      this.$refs.showGeneratedURL.show()
    },
    onClickDelete() {
      this.$emit('onClick', { type: 'function', data: this.model, func: 'onDeleteJob' })
    },
    onClickEdit() {
      this.$router.push({path: '/job/edit', query: { id: this.jobID }})
    },
    onClickActions(val) {
      if (val && val.method) {
        this[val.method](val)
      }
    },
    modeSelect(filter){
      let params = {}
      params.filter = filter && filter.bool ? filter.bool : ''
      params.job_id = this.model._id
      this.$store.dispatch('candidate/findUserCandidate', params)
      .then(res => {
        this.candidates = res.data
        if(!params.filter){
          this.$refs.modeSelect.show()
        }
      })
    },
    modeUpload(val) {
      if (val && val.bool) {
        this.$refs.createCandidate.show()
      }
      else {
        this.$refs.uploadCandidate.show()
      }
    },
    mergePartialModels(val) {
      if(!val.showError){
        if (val.isValid && val.model) {
          this.finalModel = Object.assign({}, this.finalModel, val.model)
        }
        this.finalModel.job_id = this.model._id
      }
      else{
        this.closeAllModals()
      }
    },
    capitalizeString(str) {
      let string = str || ''
      return `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`
    },
    onSelectCandidate(data){
      let uiid = data.bool
      this.loadSelectCandidate = true

      this.$store.dispatch('job/applyJob', { id: this.model._id, candidate_id: uiid })
      .then(res => {
        let data = { ...res.data }
        this.loadSelectCandidate = false
        this.$refs.modeSelect.hide()
        
        let { job_id } = data.application
        if(res.data.success){
          this.loadCandidate({ id: job_id })
          this.loadCandidate({ id: job_id, placed: true })
          this.loadCandidate({ id: job_id, rejected: true })
        }
        else this.load()

        this.$bvToast.toast(res.data.toastMessage, {
          title: 'Notification',
          variant:res.data.success ? 'success' : 'danger'
        })
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    async fetchData() {
      let jobID = this.jobID
      let defaultTemplate = '<h5 class="job_description_titles">Description / 説明</h5><p>_JOB_DESCRIPTION_</p><h5 class="job_description_titles">Open Position / オープンポジション</h5><p>_OPEN_POSITION_</p><h5 class="job_description_titles">Mandatory Skills / 必須スキル</h5><p>_MANDATORY_SKILLS_</p><h5 class="job_description_titles">Welcome Skills / ウェルカムスキル</h5><p>_WELCOME_SKILLS_</p><h5 class="job_description_titles">Recruitment Background / 採用背景</h5><p>_RECRUITMENT_BACKGROUND_</p><h5 class="job_description_titles">Target Candidate / 対象候補者</h5><p>_TARGET_CANDIDATE_</p><h5 class="job_description_titles">Welfare / 福祉</h5><p>_PERKS_</p><h5 class="job_description_titles">Holiday & Vacations / 休日・休暇</h5><p>_HOLIDAY/VACATION_</p><h5 class="job_description_titles">Work Environment / 作業環境</h5><p>_WORK_ENVIRONMENT_</p><h5 class="job_description_titles">Working Hours / 労働時間</h5><p>_WORKING_HOURS_</p><h5 class="job_description_titles">Probation / 保護観察</h5><p>_PROBATION_</p><h5 class="job_description_titles">Recruitment Period / 募集期間 </h5><p>_RECRUITMENT_PERIOD_</p><h5 class="job_description_titles">Allowances / 手当</h5><p>_ALLOWANCES_</p><h5 class="job_description_titles">Bonus / ボーナス</h5><p>_BONUS_</p><h5 class="job_description_titles">Salary raise / 昇給</h5><p>_SALARY_RAISE_</p><h5 class="job_description_titles">Interview Process / 面接プロセス</h5><p>_INTERVIEW_PROCESS_</p>'
      let items = {
        'open_position': '_OPEN_POSITION_',
        'work_life_balance': '_WORK_LIFE_BALANCE_',
        'description': '_JOB_DESCRIPTION_',
        'mandatory_skills': '_MANDATORY_SKILLS_',
        'welcome_skills': '_WELCOME_SKILLS_',
        'allowances': '_ALLOWANCES_',
        'bonus': '_BONUS_',
        'category': '_CATEGORY_',
        'holiday_vacations': '_HOLIDAY/VACATION_',
        'work_environment': '_WORK_ENVIRONMENT_',
        'recruitment_background': '_RECRUITMENT_BACKGROUND_',
        'age': '_AGE_',
        'working_hours': '_WORKING_HOURS_',
        'target_candidate': '_TARGET_CANDIDATE_',
        'recruitment_period': '_RECRUITMENT_PERIOD_',
        'probation': '_PROBATION_',
        'salary': '_SALARY_',
        'salary_raise': '_SALARY_RAISE_',
        'perks': '_PERKS_',
        'address': '_ADDRESS_',
        'city': '_CITY_',
        'interview_process': '_INTERVIEW_PROCESS_'
      }
      return this.$store.dispatch(`${this.moduleName}/${this.endpoint}`, { id: jobID })
      .then(async res => {
        if (res.data) {
          this.model = res.data
          let webcrawler_id = res.data.webcrawler
          if ( typeof res.data.webcrawler !== 'string' ) 
            webcrawler_id = res.data.webcrawler._id
          let template = await this.$store.dispatch(`${this.moduleName}/getTemplate`, { webcrawler_id: webcrawler_id })
            .then(el=>{
              let resp = el.data
              if (!resp.success) {
                return defaultTemplate
              }
              return resp.template
            })
            .catch(err=>{
              console.error(err)
              return defaultTemplate
            })
          let keys = Object.keys(this.model)
          for (let key of keys) {
            if ( keys.includes(key) ) {
              if ( !this.model[key] || this.model[key].length <= 0 ) {
                // FIXME: Remove html DOM node
                template = template.replace(items[key], '*')
                continue
              }
              if ( ['string', 'number', 'boolean'].includes(typeof this.model[key]) ) {
                template = template.replace(items[key], this.model[key])
              }
              if ( Array.isArray(this.model[key]) ) {
                let tmp = '<ul>'
                for ( let el of this.model[key] ) {
                  tmp += '<li>' + el + '</li>'
                }
                tmp += '</ul>'
                template = template.replace(items[key], tmp)
              }
            }
          }
          for (let key in items) {
            template = template.replace(items[key], '⚠️ Data not provided / データが提供されていません')
          }
          // Clean template
          let emptySectionPattern = /<h5 [^<]*>[^<]*<\/h5><p>(\*|⚠️ Data not provided \/ データが提供されていません)<\/p>/ig
          console.log('>', template.replace(emptySectionPattern, ''))
          this.job_layout = template.replace(emptySectionPattern, '')
          console.log(res.data)
          this.finalModel.job_id = this.model._id
          if (res.data.avatar_path) {
            this.$refs.avatarPath.src = res.data.avatar_path
          }
        }
      })
      .catch(err => console.log(err))
    },
    handleSubmit(val){
      this.noteCreated = true;
      let model = {}
      model.id = this.jobID
      model.note = val && val.note ? val.note : ''
      model.city = model.city.text
      
      this.$store.dispatch('job/createNote', model)
      .then(res => {
        var data = res.data;
        this.model.notes = data.notes;
        this.submitted = !this.submitted;
        this.noteCreated = false;
        this.$bvToast.toast('Note successfully added!', {
          title: 'Notification',
          variant:'success'
        })
      })
      .catch((err) => {
        this.noteCreated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    loadCompanyURL() {
      this.$store.dispatch('job/getCompanyUrl', { id: this.jobID })
      .then(res => {
        if (res && res.data) {
          this.job_company_url = res.data
        }
      })
    },
    loadURL() {
      this.$store.dispatch('job/getUrl', { id: this.jobID })
      .then(res => {
        if (res && res.data) {
          this.job_url = res.data
        }
      })
    },
    anotherInterview(){
      this.$bvModal.msgBoxConfirm('Are you sure you want to initiate another interview for this applicant? This will send an email to the employer with new link for candidates.', {
        title: 'Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.$store.dispatch('candidate/setAnotherInterview', { id:this.applicant._id })
          .then(res => {
            this.applicant = res.data
            this.$bvToast.toast(`Another interview was initiated for applicant ${res.data.full_name}!`, {
              title: 'Notification',
              variant:'success'
            })
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
    },
    validateStep(name) {
			var refToValidate = this.$refs[name]
			return refToValidate.validate()
		},
    resetWizard(){
      this.is_reset_wizard = !this.is_reset_wizard
    },
    closeErrorModal(){
      this.$refs.modalError.hide()
    },
    closeAllModals(){
      this.$refs.uploadCandidate.hide()
      this.$refs.createCandidate.hide()
      this.$refs.modalError.hide()
      this.$refs.modeSelect.hide()

      this.resetWizard()
    },
    onComplete(){
      this.$refs.uploadCandidate.hide()
      this.$refs.createCandidate.hide()
      this.$refs.modeSelect.hide()

      this.$bvToast.toast(`Application was submitted!`, {
        title: 'Notification',
        variant:'success'
      })

      this.finalModel = {
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      }

      this.$refs['uploadwizard'].reset()
      this.$refs['manualwizard'].reset()

      this.is_wizard_upload_reset = !this.is_wizard_upload_reset
      this.is_wizard_manual_reset = !this.is_wizard_manual_reset
      this.resetWizard()

      this.loadCandidate({ id: this.jobID })
      this.loadCandidate({ id: this.jobID, placed: true })
      this.loadCandidate({ id: this.jobID, rejected: true })
    },
    onActivate () {
      this.$bvModal.msgBoxConfirm('Are you sure you want to ' + (this.model.active ? 'Deactivate' : 'Activate'), {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.$store.dispatch('job/activate', this.model)
          .then(res => {
            // this.model.active = res.data.active
            this.fetchData()
            this.$bvToast.toast(`Job #${res.data.reference_no} has been ${res.data.active ? 'Activated' : 'Deactivated'}!`, {
              title: 'Notification',
              variant:'success'
            })
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onPublish(){
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to ${!this.model.published ? 'post' : 'unpost' } this job (this action is one time only).`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.toggleLoading()
          this.$store.dispatch('job/publishJob', {
            id:this.jobID,
            published: !this.model.published
          })
          .then(res => {
            if(res.data.published || !res.data.published){
              this.fetchData()
              this.model.published = res.data.published
              this.$bvToast.toast(`Job #${res.data.reference_no} has been ${!this.model.published ? 'posted' : 'unposted' }!`, {
                title: 'Notification',
                variant:'success'
              })
              this.find({
                id:this.jobID
              }).then(data => {
                this.model = data.data
              })

              // this.$emit("fetchData")
              this.loadCandidate()
              this.toggleLoading()
            }
          }).catch(err => {
            error.errorHandler(err, this.$bvToast)
            this.toggleLoading()
          })
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },

    onUpdateOriginal(){
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to update the original title and description this job.`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.toggleLoading()
          this.$store.dispatch('job/updateOriginalFields', {
            id:this.jobID
          })
          .then(res => {
            if(res.data.published || !res.data.published){
              this.fetchData()
              this.model.published = res.data.published
              this.$bvToast.toast(`Job #${res.data.reference_no} original title and description has been updated!`, {
                title: 'Notification',
                variant:'success'
              })
              this.find({
                id:this.jobID
              }).then(data => {
                this.model = data.data
              })
              this.loadCandidate()
              this.toggleLoading()
            }
          }).catch(err => {
            error.errorHandler(err, this.$bvToast)
            this.toggleLoading()
          })
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },

    loadCandidate(param){
      this.applicantLoading = !param.placed && !param.rejected
      this.placeApplicantLoading = param.placed
      this.rejectedApplicantLoading = param.rejected 
      this.applicant = {}

      this.$store.dispatch('job/getApplicants', param)
      .then(res => {

        if (res && res.data) {
          if (!param.placed && !param.rejected) {
            this.applicantProgress = false
            this.applicants = res.data || []
          }
          else if (param.placed && !param.rejected) {
            this.placed_applicants = res.data || []
            this.placeApplicantLoading = false 
          }
          else if (!param.placed && param.rejected) {
            this.rejected_applicants = res.data || []
            this.rejectedApplicantLoading = false 
          }
        }
      })
    },
    urlGenerate(company = false){
      return this.$store.dispatch('job/generateUrl', { id: this.model._id, company })
      .then(res => {
        // let urlSelector = ''
        if (res && res.data) {
          this.$refs.showGeneratedURL.show();
          this.job_param_url = res.data;

          if (company) this.job_company_url = res.data;
          else this.job_url = res.data;
          // if (company) {
          //   console.log(res.data)
          //   // urlSelector = '#copyCompanyURL'
          // }
          // else {
          //   // this.job_company_url = res.data
          //   // urlSelector = '#copyURL'
          // }
          // this.copyURL(urlSelector)
        }
      })
      .catch(err => {
        console.log("FATAL ERROR: ", err)
        return error.errorHandler(err, this.$bvToast)
      })
    },
    onCloseModal(modal){
      this.$refs[modal.bool].hide()
    }
    // copyURL(selector){
    //   let codeToCopy = document.querySelector(selector)
    //   codeToCopy.removeAttribute('hidden', 'hidden')
    //   codeToCopy.select()

    //   try {
    //     document.execCommand('copy');
    //     // alert('Job URL copied successfully');
    //   } catch (err) {
    //     // alert('Oops, unable to copy');
    //   }
    //   codeToCopy.setAttribute('hidden', 'hidden')
    //   window.getSelection().removeAllRanges()
    // }
  },
  watch: {
    jobID: function () {
      this.fetchData()
      this.loadCompanyURL()
      this.loadURL()
    },
    editSubmitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.jobID) {
      this.fetchData()
      this.loadCompanyURL()
      this.loadURL()
    } else if (this.previewData) {
      this.model = { ...this.previewData }
    }
  }
}
</script>
<style lang="scss">
  .dot_container {
    height: 3px;
    width: 3px;
    border-radius: 50%;
    background: grey;
  }

  .vincere_size {
    width: 35px;
    height: 35px;
  }
  
  .small_titles {
    font-size: 10px;
    font-weight: bolder;
  }

  .font-weight-boldest {
    font-weight: 900;
  }

  .jobs_card_container {
    padding-left: 0!important;
    padding-right: 0!important;
  }

  .small_card_container {
    width: 31%;
    height: 120px;
    padding: 15px 20px;
  }

  .small_card_content_container {
    min-height: 50px;
    overflow: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
  }

  // .note_cards::-webkit-scrollbar,
  // .tab_card_content_container::-webkit-scrollbar,
  .small_card_content_container::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  .tab_card_container {
    padding: 20px;
    // height: 250px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .tab_card_content_container {
    height: 100%;
    overflow: auto;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .note_cards {
    background: #e8eaee;
    height: 160px;
    font-weight: 600;
    overflow: auto;
    width: 49%;
    max-width: 49%;
    flex: 0 0 49%;
    padding: 15px;
  }

  .tab_description_content_container {
    // background: #e8eaee;
    font-weight: 600;
    padding: 20px;
    width: 100%;
    height: 100%;
    overflow: auto;
    p,
    span,
    ul {
      background-color: transparent!important;
    }
  }

  .meduim_card_container {
    width: 48%;
    height: 130px;
    padding: 15px 20px;
  }

  .setting_dropdown_container {
    .nav-link.dropdown-toggle.dropdown-toggle-no-caret {
      padding: 0!important;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .job_description_titles {
    margin-top: 30pt;
    margin-bottom: 10pt;
    color: #68687a;
  }
</style>